/** @format */
import React from 'react'

import { Modal, Spin } from 'antd'

import './style.css'
let modalLoading

export const Loading = {
	open() {
		modalLoading = Modal.warning({
			title: 'Cargando',
			centered: true,
			content: (
				<div>
					<div className='example'>
						<Spin />
					</div>
				</div>
			),
			footer: null,
			okButtonProps: {
				disabled: true,
			},
		})
	},
	close() {
		modalLoading.destroy()
	},
}
